import { render } from "./ToDoAdd.vue?vue&type=template&id=bf561008&ts=true"
import script from "./ToDoAdd.vue?vue&type=script&lang=ts"
export * from "./ToDoAdd.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__